import React from 'react';
import * as Sebrae from '@sebrae/react-core';

import imageHero from '../../../shared/assets/hero-urbano.png';
import imageUnctad from '../../../shared/assets/logo-unctad.png';
import CommonButton from '../../../shared/components/common-button/common-button';
import { Footer } from '../../../shared/components/footer/footer';
import HeaderWithoutAuth from '../../../shared/components/header-without-auth/header-without-auth';
import {
  Content,
  ContentButton,
  ContentDescription,
  ContentHero,
  ContentTitle,
  Description,
  GradientContainer,
  Title,
  Wrapper,
} from './without-interview-style';

export const WithoutInterview = () => {
  const { navigateTo } = Sebrae.useSebraeRouter();
  const { tokenInfo } = Sebrae.useAuth();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'space-between',
      }}
    >
      <HeaderWithoutAuth />
      <GradientContainer
        primary={'#215DF4'}
        secondary={'#699FFF'}
        tertiary={'#C5EAFF'}
      >
        <Wrapper>
          <Content>
            <ContentTitle>
              <Title>
                Você é o seu
                <br />
                maior negócio.
              </Title>
              <img src={imageUnctad} alt="imageUnctad" />
            </ContentTitle>
            <ContentDescription>
              <Description>
                {`Olá ${tokenInfo?.name?.trim()}, vimos que você não possui uma entrevista ` +
                  'de seleção para ser respondida no Empretec. '}
              </Description>
              <Description>
                Caso não tenha realizado o seminário e deseje conhecer mais,
                acesse o Portal do Sebrae através do link abaixo.
              </Description>
            </ContentDescription>
            <ContentButton>
              <CommonButton
                variant="primary"
                isBold={true}
                backgroundColor="#0000C7"
                onClick={() => {
                  navigateTo('/portal');
                }}
              >
                Acesse o Portal do Sebrae
              </CommonButton>
            </ContentButton>
          </Content>
          <ContentHero>
            <img src={imageHero} alt="hero" />
          </ContentHero>
        </Wrapper>
      </GradientContainer>
      <Footer />
    </div>
  );
};
